// extracted by mini-css-extract-plugin
export default {"modelName":"ModelSwitcher-module__modelName--cIho5","selectAnchor":"ModelSwitcher-module__selectAnchor--qDYTV"};